<template>
  <div>
    <v-row>
      <v-expansion-panels accordion multiple v-model="panelsActive">
        <template v-for="(zone, index) in zones">
          <v-expansion-panel
            :key="`zone${index}`"
            v-if="selectedZone === '0' || selectedZone === zone.id"
          >
            <v-expansion-panel-header
              :id="`zone${zone.id}`"
              :data-index="index"
              disable-icon-rotate
            >
              {{ zone.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <template v-for="(table, index) in tables(zone.id)">
                <span :class="tableWithItem(table)" :key="index">
                  <v-btn
                    v-if="
                      hasState(table) && color(table) && tableHasOrdered(table)
                    "
                    :key="`table${index}`"
                    class="ma-2 white--text"
                    :id="`table${table.table}`"
                    :color="color(table).color"
                    rounded
                    large
                    @click="
                      openDialog(table.table, color(table), tableOrders(table))
                    "
                    >{{ table.table }}
                  </v-btn>
                </span>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
    </v-row>

    <OpenOrderByTableDialog
      :selectedPrinters="selectedPrinters"
      :selectedPrinterTicket="selectedPrinterTicket"
      :selectedDrawer="selectedDrawer"
      ref="orderDialog"
      @changeTableToMarcharSegundo="changeTableToMarcharSegundo"
      :cashDrawers="cashDrawers"
    ></OpenOrderByTableDialog>
  </div>
</template>

<script>
import { every } from "lodash";
import { paymentsCollection, updatePayment } from "@/collections/payments";
import { qrCollection } from "@/collections/qrs";
import { qrZoneCollection } from "@/collections/qrZone";
import OpenOrderByTableDialog from "@/components/admin/order/OpenOrderByTableDialog";
import moment from "moment";
import { ordersTotalByTableCollection } from "@/collections/ordersTotalByTable";
const GREEN = {
  color: "#4caf50",
  name: "green",
  value: 0
};
const ORANGE = {
  color: "#fb8c00",
  name: "orange",
  value: 1
};
const RED = {
  color: "#ff5252",
  name: "red",
  value: 2
};

const GREY = {
  color: "#9e9e9e",
  name: "gret",
  value: 3
};

export default {
  name: "open-order-by-zone",
  props: {
    selectedPrinters: Array,
    orders: Object,
    selectedZone: String,
    selectedState: Number,
    selectedPrinterTicket: Object,
    search: String,
    selectedDrawer: Object,
    cashDrawers: Array
  },
  components: {
    OpenOrderByTableDialog
  },
  data() {
    return {
      colors: {
        GREEN,
        ORANGE,
        RED
      },
      zones: [],
      qr: [],
      ordersTotal: [],
      openPayments: [],
      panelsActive: []
    };
  },
  firestore() {
    return {
      zones: qrZoneCollection,
      qr: qrCollection,
      ordersTotal: ordersTotalByTableCollection
    };
  },
  mounted() {
    try {
      paymentsCollection
        .where("payment_on", "==", null)
        .onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            let checkBlinkedAvailable = change.doc.data().isBlinked
              ? change.doc.data().isBlinked
              : null;
            if (change.type === "added" && checkBlinkedAvailable === null) {
              this.playMusic();
              this.notificationBlink(change.doc.data().tableQR);
              updatePayment(change.doc.id, {
                isBlinked: true,
                updated_on: moment().format()
              }).catch(error => {
                this.setlogError(
                  "update_payment",
                  "Obtained error message in mounted()",
                  error.stack,
                  this.$options.name
                );
              });
            }
          });
        });
    } catch (error) {
      this.setlogError(
        "paymentsCollection",
        "Obtained error message in mounted()",
        error.stack,
        this.$options.name
      );
    }
  },
  watch: {
    search(val) {
      this.panelsActive = [];
      if (val) {
        for (const [key] of Object.entries(this.orders)) {
          let tableQR = this.qr.find(x => x.table === key);
          if (tableQR !== undefined) {
            let zoneIndex = this.zones.findIndex(x => x.id === tableQR.zone_id);
            this.panelsActive.push(zoneIndex);
          }
        }
      }
    },
    zones(newValue) {
      newValue.forEach((x, i) => {
        this.panelsActive.push(i);
      });
    }
  },
  methods: {
    hasOrdersOpenInZone(zoneId) {
      let tables = this.tables(zoneId);
      let found = false;
      tables.forEach(table => {
        if (
          this.hasState(table) &&
          this.color(table) &&
          this.tableHasOrdered(table)
        ) {
          found = true;
        }
      });

      return found;
    },
    playMusic() {
      let audio = new Audio(this.projectUrl + "/music/OneRingfromDeskBell.mp3");
      audio.play();
    },
    openDialog(table, color, orders) {
      if (color.value === 3) {
        this.showInfoMessage("Esta mesa no tiene pagos pendientes");
        return;
      }

      orders = orders.map(item => {
        if (!item.isDelivered) {
          item.isDelivered = false;
        }
        return item;
      });

      const remaining = this.getOrderTotalByTable(table).remaining;
      this.$refs.orderDialog.open(remaining, table, color.color, orders);
      this.removeBlink(table);
    },
    tables(zoneId) {
      return this.qr.filter(x => x.zone_id === zoneId && x.active === true);
    },
    tableOrders(table) {
      return this.orders[table.table];
    },
    hasState(table) {
      if (this.selectedState === -1) {
        return true;
      }

      const color = this.color(table);
      if (color === undefined) {
        return false;
      }

      return color.value === this.selectedState;
    },
    getOrderTotalByTable(table) {
      return this.ordersTotal.find(x => x.tableQR === table);
    },
    tableHasOrdered(table) {
      let orders = this.tableOrders(table);
      return !orders ? false : true;
    },
    color(table) {
      let orders = this.tableOrders(table);

      // table closed
      if (!orders) {
        return GREY;
      }

      // get remaining to pay amount for the table
      let orderByTableTotal = this.getOrderTotalByTable(table.table);
      if (!orderByTableTotal) return;

      // get orders total
      let orderTotal = orders
        .map(el => el.quantity * el.price + this.totalWithAdditionalCharge(el))
        .reduce((accumulator, currentValue) => accumulator + currentValue);

      // 1. if everything is paid
      if (orderByTableTotal.remaining === 0) {
        return GREEN;
      }

      // 2. if everything is remaining to paid
      if (
        parseFloat(orderTotal).toFixed(2) ===
        parseFloat(orderByTableTotal.remaining).toFixed(2)
      ) {
        return RED;
      }

      // 3. if partially paid
      return ORANGE;
    },
    hasUseTable(zone) {
      let self = this;
      let tables = this.tables(zone.id);
      return tables.some(item => {
        if (self.orders[item.table]) {
          return true;
        }
      });
    },
    notificationBlink(table) {
      if (table && document.getElementById("table" + table)) {
        document.getElementById("table" + table).classList.add("blink_me");
      }
      this.blinkPanel(table);
    },
    removeBlink(table) {
      if (table && document.getElementById("table" + table)) {
        document.getElementById("table" + table).classList.remove("blink_me");
      }
    },
    blinkPanel(table) {
      if (table) {
        const tableObj = this.qr.find(t => t.table === table);
        console.log("tableObj", tableObj);
        if (
          tableObj &&
          tableObj.zone_id &&
          document.getElementById("zone" + tableObj.zone_id)
        ) {
          const panelHeaderEl = document.getElementById(
            "zone" + tableObj.zone_id
          );
          console.log("panelHeader", panelHeaderEl);
          const panelIndex = panelHeaderEl.getAttribute("data-index");
          console.log("panelIndex", panelIndex);
          this.panelsActive = this.panelsActive.filter(
            idx => idx === panelIndex
          );
          setTimeout(() => {
            panelHeaderEl.classList.add("blink_me");
          }, 500);
        }
      }
    },
    tableWithItem(table) {
      let tableQR = this.qr.find(item => item.table === table);
      if (tableQR) {
        table = tableQR;
      }

      const { food } = this.$store.state.productTypeIds;
      const { dessert } = this.$store.state.productTypeIds;
      let orders = this.tableOrders(table);

      if (!orders) {
        return "";
      }

      let menuGroupOrder = orders.find(x => x.isMenuGroupProduct);
      if (menuGroupOrder) {
        let groupOrder = [
          ...menuGroupOrder.starters,
          ...menuGroupOrder.maincourse,
          ...menuGroupOrder.desserts,
          ...menuGroupOrder.drinks
        ];
        let isPrinted = groupOrder.filter(x => x.isPrinted === true);
        let hasDessert = menuGroupOrder.desserts;
        let hasMainCourse = menuGroupOrder.maincourse;

        let foundMainCourseChecked = groupOrder.filter(item => {
          if (item.isDeliveredMainCourse) {
            return item;
          }
        });

        let allChecked = every(foundMainCourseChecked, [
          "isDeliveredMainCourse",
          true
        ]);

        if (hasMainCourse.length > 0) {
          if (
            hasDessert.length > 0 &&
            isPrinted.length > 0 &&
            foundMainCourseChecked.length > 0 &&
            allChecked
          ) {
            return "oval dessert_oval";
          }
          if (isPrinted.length > 0) {
            return "oval delivered_oval";
          }
          return "oval maincourse_oval";
        }

        if (hasDessert.length > 0 && isPrinted.length > 0) {
          return "oval delivered_oval";
        }

        if (
          hasDessert.length > 0 &&
          foundMainCourseChecked.length > 0 &&
          allChecked
        ) {
          return "oval dessert_oval";
        }
        return "";
      }

      let isPrinted = orders.filter(x => x.isPrinted === true);
      let hasDessert = this.getItemsOrders(
        dessert,
        orders,
        "dessert",
        table.table
      );
      let hasMainCourse = this.getItemsOrders(
        food,
        orders,
        "food",
        table.table
      );

      let foundMainCourseChecked = orders.filter(item => {
        if (item.isDeliveredMainCourse) {
          return item;
        }
      });

      let allChecked = every(foundMainCourseChecked, [
        "isDeliveredMainCourse",
        true
      ]);

      if (hasMainCourse.length > 0) {
        if (
          hasDessert.length > 0 &&
          isPrinted.length > 0 &&
          foundMainCourseChecked.length > 0 &&
          allChecked
        ) {
          return "oval dessert_oval";
        }
        if (isPrinted.length > 0) {
          return "oval delivered_oval";
        }
        return "oval maincourse_oval";
      }

      if (hasDessert.length > 0 && isPrinted.length > 0) {
        return "oval delivered_oval";
      }

      if (
        hasDessert.length > 0 &&
        foundMainCourseChecked.length > 0 &&
        allChecked
      ) {
        return "oval dessert_oval";
      }
      return "";
    },
    // eslint-disable-next-line no-unused-vars
    getItemsOrders(product_type_id, orders, type, table) {
      if (type === "food") {
        return orders.filter(
          x =>
            x.product_type_id === product_type_id &&
            x.metadata &&
            x.canBeMainCourse &&
            !x.canBeShared
        );
      }

      return orders.filter(item => item.product_type_id === product_type_id);
    },
    changeTableToMarcharSegundo(table) {
      this.tableWithItem(table);
    }
  }
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 767px) {
  .v-expansion-panel-header {
    flex-direction: column;
    align-items: flex-start;
    padding-left: 5px;
    padding-right: 8px;
  }
  .v-expansion-panel-header__icon .row {
    margin-top: 10px;
  }
}
@media screen and (max-width: 393px) {
  .v-expansion-panel-header {
    padding-right: 3px;
  }
}
@media screen and (max-width: 375px) {
  .mb-div-width {
    width: 50%;
    margin: 5px 0;
  }
}
.blink_me {
  animation: glowing 700ms infinite;
}
@keyframes glowing {
  0% {
    background-color: #ff5252;
  }
  50% {
    background-color: #9e9e9e;
  }
  100% {
    background-color: #ff5252;
  }
}

.oval {
  padding: 22px 2px 22px 2px;
  margin-right: 10px;
  border-radius: 100px/80px;
  margin-left: 2px;
}
.maincourse_oval {
  background: linear-gradient(
    to right,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 127, 0, 1) 25%,
    rgba(255, 229, 170, 1) 50%,
    rgba(85, 252, 246, 1) 75%,
    rgba(155, 255, 68, 1) 100%
  );
}
.delivered_oval {
  background-color: #d2bfa5;
}
.dessert_oval {
  background-color: #735d55;
}
</style>
